import React from 'react';
import './basement.scss';

import  CContactForm from '../contactform/ccontactform.js';
import { Link } from 'react-router-dom';

class Basement extends React.Component {
  constructor(props) {
    super(props);
  };
  componentWillMount() {
  };
  render() {
    return (
      <section className='basement-wrap f-center'>
        <div className='title-fone' />
        <div className='f-container'>
          <div className='f-row'>
            <div className='f-item f-item-3'>
              <div className='basement-item'>
                <h5>Посилання</h5>
                <ul className='basement-link'>
                  <li className='basement-item-contact'><Link to='/home/category/consumer/rules'><span>Правила постачання</span><i className='glyphicon glyphicon-triangle-right' /></Link></li>
                  <li className='basement-item-contact'><Link to='/home/category/consumer/rights'><span>Права та обовязки</span><i className='glyphicon glyphicon-triangle-right' /></Link></li>
                  <li className='basement-item-contact'><Link to='/home/category/consumer/dispute'><span>Порядок врегулювання спорів</span><i className='glyphicon glyphicon-triangle-right' /></Link></li>
                  <li className='basement-item-contact'><Link to='/home/category/other/law'><span>Законодавство</span><i className='glyphicon glyphicon-triangle-right' /></Link></li>
                  <li className='basement-item-contact'><Link to='/home/category/other/links'><span>Корисні посилання</span><i className='glyphicon glyphicon-triangle-right' /></Link></li>

                </ul>
              </div>
            </div>
            <div className='f-item f-item-4'>
              <div className='basement-item'>
                <h5>Контакти:</h5>
                <ul>
                  <li className='basement-item-contact'><i className='glyphicon glyphicon-map-marker' /><span>Україна, м. Херсон, вул. Михайлівська (Петренка), 18, офіс 108</span></li>
                  <li className='basement-item-contact'><i className='glyphicon glyphicon-envelope' /><span>secretary@gasup.in.ua</span></li>
                  {/*<li className='basement-item-contact'><i className='glyphicon glyphicon-earphone' /><span>Тел.: +38 (0552) 31-69-00</span></li>
                  <li className='basement-item-contact'><i className='glyphicon glyphicon-earphone' /><span>Моб.: +38 (067) 011-69-00, +38 (066) 131-69-00</span></li>*/}
                  <li className='basement-item-contact'><i className='glyphicon glyphicon-earphone' /><span>Моб.: +38 (063) 616-13-52</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };
};

export default Basement;



// WEBPACK FOOTER //
// ./src/client/components/basement/basement.jsx